import React, { useEffect, useState } from "react";
import { useThemeMode } from './theme/colorThemeContext';
import getTheme from './theme/theme';
import { CssBaseline, ThemeProvider as MuiThemeProvider, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { ToastProvider } from './components/ToastContext';
import { registerSessionExpiredHandler, registerToast } from './Utils/common';


import App from "./App";

const ThemedApp = () => {
  const { mode } = useThemeMode();
  const [toast, setToast] = useState({ show: false, message: '', variant: 'danger' });
  const [sessionExpiredDialog, setSessionExpiredDialog] = useState({
    open: false,
    message: "",
  });

  useEffect(() => {
    registerToast((message, variant = "danger") => {
      setToast({
        show: true,
        message,
        variant,
      });
    });

    registerSessionExpiredHandler((message) => {
      setSessionExpiredDialog({
        open: true,
        message:
          message || "Your session has expired. Please login again.",
      });
    });
  }, []);

  const handleSessionLogin = () => {
    setSessionExpiredDialog({
      open: false,
      message: "",
    });

    globalThis.location.href = "/login";
  };

const muiTheme = React.useMemo(
  () => getTheme(mode),
  [mode]
);
  return (
    <MuiThemeProvider theme={muiTheme}>
      <CssBaseline />

      {/* Generic Error Dialog */}
      <Dialog
        open={toast.show}
        onClose={() =>
          setToast({
            show: false,
            message: "",
            variant: "danger",
          })
        }
      >
        <DialogTitle
          sx={{
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          Something went wrong
        </DialogTitle>

        <DialogContent>{toast.message}</DialogContent>

        <DialogActions>
          <Button
            onClick={() =>
              setToast({
                show: false,
                message: "",
                variant: "danger",
              })
            }
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>

      {/* Session Expired Dialog */}
      <Dialog
        open={sessionExpiredDialog.open}
        onClose={() => {}}
        disableEscapeKeyDown
      >
        <DialogTitle
          sx={{
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          Session Expired
        </DialogTitle>

        <DialogContent>
          {sessionExpiredDialog.message}
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            onClick={handleSessionLogin}
          >
            Login
          </Button>
        </DialogActions>
      </Dialog>

      <ToastProvider>
        <App />
      </ToastProvider>
    </MuiThemeProvider>
  );
};

export default ThemedApp;
